// extracted by mini-css-extract-plugin
module.exports = {"codeSnippet":"src-components-CodeSnippetComponent-index-module__codeSnippet--3d63x","code":"src-components-CodeSnippetComponent-index-module__code--H5Em1"};